import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import numeral from 'numeral';
import { Flex, Text } from 'rebass/styled-components';
import theme from 'styled-theming';

const backgroundColor = theme('mode', {
  light: (props) => props.theme.colors.ghostWhite,
  dark: (props) => props.theme.colors.lpGhost,
});

const textColor = theme('mode', {
  light: (props) => props.theme.colors.teal,
  dark: (props) => props.theme.colors.white,
});

const AnalyticsWrapper = styled(Flex)`
  background-color: ${backgroundColor};
  color: ${textColor};
  border-radius: ${(props) => props.theme.radius.medium};
`;

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const AnalyticsOverflowItem = (props) => {
  const { data, mode } = props;

  const label = capitalize(data.name ? data.name : mode);
  const count = typeof data === 'object' ? data.count : data;
  const format = count > 1000 ? '0.0a' : '0a';

  return (
    <AnalyticsWrapper
      alignItems="center"
      justifyContent="space-between"
      mt={1}
      mode={mode}
      p={2}
      fontSize={0}
      data-testid="analytics-overflow-item"
    >
      <Text data-testid="analytics-overflow-item-subtitle">
        {label}
      </Text>
      <Text data-testid="analytics-overflow-item-count">
        {numeral(count).format(format)}
      </Text>
    </AnalyticsWrapper>
  );
};

AnalyticsOverflowItem.defaultProps = {
  mode: 'item',
  data: undefined,
};

AnalyticsOverflowItem.propTypes = {
  mode: PropTypes.string,
  data: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.number,
  ]),

};

export default AnalyticsOverflowItem;
